export default {
  'infobits.sort.title': {
    name: 'Alphabetically',
    icon: 'sort-alpha-asc',
    titleLabel: 'Sort childs alphabetically'
  },
  'infobits.sort.date': {
    name: 'By date',
    icon: 'calendar-o',
    titleLabel: 'Sort childs by creation date'
  },
  'infobits.sort.manual': {
    name: 'Manually',
    icon: 'hand-stop-o',
    titleLabel: 'Allow manual child order'
  }
}



// WEBPACK FOOTER //
// ./src/infobit-sortmodes.js